export type WidgetConfig = "widgetConfig" | "universalWidgetConfig";
export type WidgetConfigMetaData = {
  methodName: WidgetConfig;
  params?: Record<string, string>;
  apiParamsMapping?: Record<string, string>;
};

export const WIDGET_CONFIGS: Record<string, WidgetConfigMetaData[]> = {
  WIDGETS: [
    {
      methodName: "widgetConfig" as const,
      params: {
        tokenSymbol: "string",
        address: "string",
        amount: "string",
        network: "string",
        lockNetwork: "boolean",
        themeMode: "dark|light",
        exchangeIds: "string[]",
        clientTxId: "string",
        callbackUrl: "string",
        isInternalTransfer: "boolean",
      },
    },
    {
      methodName: "universalWidgetConfig" as const,
      params: {
        tokenSymbol: "string",
        address: "string",
        amount: "string",
        network: "string",
        lockNetwork: "boolean",
        themeMode: "dark|light",
        exchangeIds: "string[]",
        clientTxId: "string",
        callbackUrl: "string",
        isInternalTransfer: "boolean",
      },
    },
  ] as const,
};
